module.exports = __webpack_public_path__ + "img/outsourcing-image-01.593f0efc.jpg";